// src/hooks/useAppBar.tsx
import { useContext, createContext, useState, type ReactNode } from "react";

interface AppBarContextType {
    title: string;
    setTitle: (title: string) => void;
    actions: ReactNode;
    setActions: (actions: ReactNode) => void;
    onMenuClick?: () => void;
    setOnMenuClick: (callback: () => void) => void;
}

const AppBarContext = createContext<AppBarContextType | undefined>(undefined);

export function AppBarProvider({ children }: { children: ReactNode }) {
    const [title, setTitle] = useState("");
    const [actions, setActions] = useState<ReactNode>(null);
    const [onMenuClick, setOnMenuClick] = useState<(() => void) | undefined>(undefined);

    return (
        <AppBarContext.Provider
            value={{ title, setTitle, actions, setActions, onMenuClick, setOnMenuClick }}
        >
            {children}
        </AppBarContext.Provider>
    );
}

export function useAppBar() {
    const context = useContext(AppBarContext);
    if (context === undefined) {
        throw new Error("useAppBar must be used within an AppBarProvider");
    }
    return context;
}
